import { cachePageInstances, IS_PREVIEW } from '../share';
import { isSubRoute } from '../utils';

declare const MAX_ROUTES: Record<string, string>;

export function clearPagesCache(route: string) {
  const deleted: string[] = Object.keys(MAX_ROUTES).filter((subRoute) => isSubRoute(route, subRoute)) ?? [];
  deleted.forEach((d) => {
    const pageCode = MAX_ROUTES[d];
    const pageInstance = cachePageInstances.get(pageCode);
    if (pageInstance) {
      // 即使是当前页面也要清楚缓存，因为 clearPagesCache 的含义就是清空route下面所有子页面的缓存
      cachePageInstances.delete(pageCode);

      if (
        // 预览环境下，当前路由的页面不需要执行onUnload生命周期
        (IS_PREVIEW && history.state.pureRoute === d) ||
        // 产物环境下，当前路由的页面不需要执行onUnload生命周期
        d === location.pathname.substring(1)
      ) {
        return;
      } else {
        // 销毁页面实例前先执行生命周期
        pageInstance.onUnload?.();
      }
    }
  });
}
